import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import getRoutes from './Routes/Routes';
// NOTE: Responsive.scss is now included in the theme bundles (style.css / style-dark.css)
// so we don't duplicate it into app.css.

import { AuthProvider } from './Modules/Core/Context/AuthContext';

import AuthGaurd from './Modules/Core/Components/AuthGaurd/AuthGaurd';
import {
  Loader,
  ErrorFallback,
  GlobalProvider,
  AppNotifications,
} from 'smart-react';
import TsxProbe from './Modules/Core/Components/TsxProbe/TsxProbe';
const MetaTags = React.lazy(
  () => import('./Modules/Core/Components/MetaTags/Tags'),
);
const DrawerRouterContainer = React.lazy(
  () =>
    import(
      /* webpackPreload: true */ './Modules/Core/Components/Drawer/DrawerRouterContainer'
    ),
);

function App() {
  return (
    <React.Suspense fallback={<Loader />}>
      <TsxProbe />
      <React.Suspense>
        <MetaTags />
      </React.Suspense>
      <GlobalProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // reset the state of your app so the error doesn't happen again
          }}
        >
          <React.Suspense>
            <AppNotifications />
          </React.Suspense>
        </ErrorBoundary>

        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<AuthGaurd />}>
                <Route path='/' element={<DrawerRouterContainer />}>
                  {getRoutes('DashboardLayout')}
                  {getRoutes('CardLayout')}
                  {getRoutes('TileLayout')}
                </Route>
                {getRoutes('AuthEmptyLayout')}
              </Route>
              {getRoutes('EmptyLayout')}
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </GlobalProvider>
    </React.Suspense>
  );
}

export default App;
